import { post, del } from './requests'

const resourcePath = 'uploaded_signatures'

export function createUploadedSignature (uploadedSignature) {
  return post(resourcePath, { uploadedSignature })
}

export function deleteUploadedSignature (id) {
  return del(`${resourcePath}/${id}`)
}
